import script from "./cookiesGST.vue?vue&type=script&setup=true&lang=js"
export * from "./cookiesGST.vue?vue&type=script&setup=true&lang=js"

import "./cookiesGST.vue?vue&type=style&index=0&id=e26d2ae2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e26d2ae2"]])

export default __exports__